const namespaced = true

const state = {
    showSplashscreen: false,
    showPassword: true,
    showHelp: false

}

const actions = {

}
const mutations = {
    setShowSplash: (state, data) => {
        state.showSplashscreen = data;
    },
    setShowPassword: (state, data) => {
        state.showPassword = data;
    },
    setShowHelp: (state, data) => {
        state.showHelp = data;
    },
}
const getters = {
}

export const splashscreen = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
